import React, { useRef, useState } from "react";
import Button from "@shared/v2/Button";
import Checkbox from "@shared/v2/Checkbox";
import { Product } from "../Support/Account/AddOnsSupport/types";

interface Step3Props {
  children?: React.ReactNode;
  onBack: () => void;
  onAccept: () => void;
  product: Product;
}

const Step3: React.FC<Step3Props> = ({ children, onBack, onAccept, product }) => {
  const termsRef = useRef<HTMLDivElement>(null);
  const [atBottom, setAtBottom] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const handleScroll = () => {
    const el = termsRef.current;
    if (el) {
      const threshold = 8;
      setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - threshold);
    }
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-[24px]">
      <div className="tw-relative">
        <div
          ref={termsRef}
          className="tw-p-[24px] tw-max-h-[330px] tw-rounded-[8px] tw-border-solid tw-border-[2px] tw-border-gray-10 tw-overflow-y-auto"
          onScroll={handleScroll}
        >
          {children}
          {!atBottom && (
            <div className="tw-text-center tw-sticky tw-bottom-[-16px]">
              {/* @ts-expect-error props */}
              <Button
                className="tw-shadow-[0_1px_12px_5px_rgba(51,51,51,0.25)]"
                onClick={() => {
                  const el = termsRef.current;
                  el?.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
                }}
              >
                Scroll to Bottom
              </Button>
            </div>
          )}
        </div>
      </div>
      <div>
        {/* @ts-expect-error props */}
        <Checkbox
          checked={accepted}
          onChange={() => setAccepted((a) => !a)}
          disabled={!atBottom}
          label={`I accept the ${product.baseName} Terms of Use and have the authority to make this purchase.`}
          isRequired
        />{" "}
        <span className="tw-text-semantic-red-50">*</span>
      </div>
      <div className="tw-flex tw-justify-between tw-gap-[16px]">
        {/* @ts-expect-error props */}
        <Button size="medium" schema="tertiary" onClick={onBack}>
          Back
        </Button>
        <div className="tw-flex tw-gap-[16px]">
          <div className="tw-flex tw-flex-col tw-items-end tw-text-gray-50">
            <div>The following amount will be added to</div>
            <div>
              your monthly Brivity bill:{" "}
              <span className="tw-font-semibold">${product.details.unitPrice}</span>{" "}
              {/* <span className="tw-text-semantic-green-100 tw-font-semibold">$90.00</span> */}
            </div>
          </div>
          {/* @ts-expect-error props */}
          <Button size="medium" onClick={onAccept} disabled={!accepted}>
            Accept & Pay
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Step3;
